import * as yup from 'yup';

const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 МБ

const SUPPORTED_FORMATS = [
  // Документы
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx

  // Изображения
  'image/png',
  'image/jpeg',
  'image/jpg', // (обычно 'image/jpeg', но лучше учесть оба)
];

interface ValidateProps {
  onlyLetters?: boolean;
  required?: boolean;
  message?: string;
  fieldName?: string;
}

const withTextRequired = (yup: yup.StringSchema, props?: ValidateProps) => {
  return props?.required
    ? yup
        .required(props?.message ?? 'Fill the field')
        .min(
          2,
          props?.fieldName ? `${props.fieldName} is too short` : 'To short'
        )
    : yup;
};

const withMixedRequired = (
  yup: yup.MixedSchema<FileList | undefined>,
  props?: ValidateProps
) => {
  return props?.required
    ? yup.test('required', props.message ?? 'Fill the field', (filelist) => {
        if (!filelist || filelist.length === 0) {
          return false; // Если файла нет и поле не обязательное — валидация пройдена
        }
        return true;
      })
    : yup.notRequired();
};

const text = (fieldName: string, props?: ValidateProps) => {
  return withTextRequired(yup.string(), props)
    .matches(
      props?.onlyLetters ? /^[A-Za-z]+$/ : /.*/,
      `${fieldName} should contain only letters`
    )
    .max(500, `${fieldName} is too long`)
    .min(3, `${fieldName} is too short`);
};

const email = yup.string().required('Fill the field').email('Incorrect email');

const file = (props?: ValidateProps) =>
  withMixedRequired(
    yup
      .mixed<FileList>()
      .test(
        'fileFormat',
        'Unsupported file format (only PDF/DOC/DOCX/PNG/JPG/JPEG)',
        (filelist) => {
          if (!filelist || filelist.length === 0) {
            return true; // Если файла нет и поле не обязательное — валидация пройдена
          }
          const file = filelist[0];
          return SUPPORTED_FORMATS.includes(file.type);
        }
      )
      .test('fileSize', 'File is to large (max. 20 MB)', (filelist) => {
        if (!filelist || filelist.length === 0) {
          return true; // Если файла нет и поле не обязательное — валидация пройдена
        }
        const file = filelist[0];
        return file.size <= MAX_FILE_SIZE;
      }),
    props
  );

const telegram = yup
    .string()
    .required('Fill the field')
    .matches(
        /^https:\/\/(t\.me|telegram\.me)\/[a-zA-Z0-9_]+$/,
        'Incorrect Telegram link (example: https://t.me/username)'
    );

const portfolio_link = yup
    .string()
    .nullable()
    .transform(value => value === '' ? null : value)
    .matches(
        /^https:\/\//,
        'Portfolio link must start with https://'
    )
    .url('Please enter a valid Portfolio link')
    .optional();

const select = (props?: ValidateProps) => {
  const validate = yup.number().typeError(props?.message ?? 'Invalid type');
  const withrequired = props?.required
    ? validate.required(props?.message ?? 'Field the field')
    : validate.notRequired();

  return withrequired;
};

export const formRules = {
  text,
  select,
  email,
  file,
  telegram,
  portfolio_link
};
